import React from "react";
import { useSelector } from "react-redux";
import { Redirect } from "react-router-dom";

/**
 * Accès aux features « alpha » du BO devis, par utilisateur — dans TOUS les
 * environnements : une alpha n'est visible que si son slug figure dans
 * `admin_user.alpha_features` (fiche admin Sonata, exposé par /api/me.json).
 * Les slugs vivent côté API dans `AdminUser::ALPHA_FEATURES`
 * (rotation_carte, rapprochement_bancaire, dashboard_data).
 */
export const hasAlphaAccess = (alphaFeatures, slug) =>
  (alphaFeatures || []).includes(slug);

/** Hook : l'utilisateur connecté a-t-il accès à cette alpha ? */
export const useAlphaAccess = (slug) => {
  const alphaFeatures = useSelector(
    (s) => (s.common && s.common.user && s.common.user.data && s.common.user.data.alpha_features) || []
  );
  return hasAlphaAccess(alphaFeatures, slug);
};

/**
 * HOC pour les routes : rend le composant si l'alpha est accessible, sinon
 * redirige vers l'accueil (rien tant que /api/me.json n'est pas chargé, pour
 * ne pas rediriger à tort pendant le boot).
 */
const withAlphaAccess = (slug, Component) => (props) => {
  const userState = useSelector((s) => (s.common && s.common.user) || {});
  const allowed = hasAlphaAccess(userState.data && userState.data.alpha_features, slug);
  if (!allowed) {
    if (!userState.isInitialized) return null;
    return <Redirect to="/" />;
  }
  return <Component {...props} />;
};

export default withAlphaAccess;
